import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { checkOrderDates, dateTodayOrInFutureValidator } from 'src/app/common/date/date-validators';
import { ConfigDto } from 'src/app/shared/models/config/config-dto.model';

import { SingleOrderViewModel } from './single-order-view-model';

export function getSingleOrderForm(
  config: ConfigDto,
  singleOrderViewModel: SingleOrderViewModel,
  formBuilder: UntypedFormBuilder
): UntypedFormGroup {
  return formBuilder.group(
    {
      _id: [singleOrderViewModel._id],
      deliveryDate: [
        singleOrderViewModel.deliveryDate,
        singleOrderViewModel.deliveryDateUnknown ? null : [Validators.required, dateTodayOrInFutureValidator],
      ],
      startDate: [
        singleOrderViewModel.startDate,
        singleOrderViewModel.deliveryDateUnknown ? null : [Validators.required],
      ],
      endDate: [
        singleOrderViewModel.endDate,
        singleOrderViewModel.deliveryDateUnknown ? null : [Validators.required, dateTodayOrInFutureValidator],
      ],
      deliveryAddress: [singleOrderViewModel.deliveryAddress, Validators.required],
      deliveryInformation: [
        singleOrderViewModel.deliveryInformation,
        config?.deliveryInformation && config?.deliveryInformationRequired ? Validators.required : null,
      ],
      deliveryOption: [
        singleOrderViewModel.deliveryOption,
        config?.deliveryOptions?.length &&
        config?.orderConfig?.deliveryOption?.show &&
        config?.orderConfig?.deliveryOption?.required
          ? Validators.required
          : null,
      ],
      deliveryStartTime: [singleOrderViewModel.deliveryStartTime],
      deliveryNote: [singleOrderViewModel.deliveryNote],
      orderedArticleLines: [singleOrderViewModel.orderedArticleLines],
      accountingMonth: [singleOrderViewModel.accountingMonth, Validators.required],
      tags: [singleOrderViewModel.tags || []],
    },

    { validator: checkOrderDates }
  );
}
export function getAddionalSingleOrderViewModelForm(
  singleOrderViewModel: SingleOrderViewModel,
  formBuilder: UntypedFormBuilder
): UntypedFormGroup {
  return formBuilder.group(
    {
      _id: [singleOrderViewModel._id],
      deliveryDate: [singleOrderViewModel.deliveryDate, [Validators.required, dateTodayOrInFutureValidator]],
      deliveryAddress: [singleOrderViewModel.deliveryAddress, Validators.required],
    },
    { validator: checkOrderDates }
  );
}

export function addSingleOrderAddressControls(
  form: UntypedFormGroup,
  singleOrderViewModel: SingleOrderViewModel,
  formBuilder: UntypedFormBuilder
): void {
  form.addControl(
    'deliveryAddressName',
    formBuilder.control(singleOrderViewModel.deliveryAddress.name, Validators.required)
  );
  form.addControl(
    'deliveryAddressAddress',
    formBuilder.control(singleOrderViewModel.deliveryAddress.address, Validators.required)
  );
  form.addControl(
    'deliveryAddressPostalCode',
    formBuilder.control(singleOrderViewModel.deliveryAddress.postalCode, Validators.required)
  );
  form.addControl(
    'deliveryAddressCity',
    formBuilder.control(singleOrderViewModel.deliveryAddress.city, Validators.required)
  );
}
